import {Editor} from '@tiptap/react';
import {useEffect, useReducer} from 'react';

export function useEditorTransaction(editor: Editor | null): void {
    const [, bump] = useReducer((count: number) => count + 1, 0);

    useEffect(() => {
        if (!editor) return undefined;

        editor.on('transaction', bump);
        editor.on('selectionUpdate', bump);

        return () => {
            editor.off('transaction', bump);
            editor.off('selectionUpdate', bump);
        };
    }, [editor]);
}
